import get from 'lodash.get'
import { useContext } from 'react'
import { PartnerContext } from '../models/PartnerProvider'

const usePartner = key => {
  const partner = useContext(PartnerContext)

  return typeof key === 'string' && partner ? get(partner, key) : partner
}

export default usePartner
